import * as React from 'react';
import {Field} from 'redux-form';
import {Col, ControlLabel, FormGroup, Row} from 'react-bootstrap';
import FieldFormControl from '../../../../../../components/FieldFormControl/index';
import {isRequired} from '../../../../../../util/validators';
import {IQuoteState} from '../../../../../../services/quote/models';

interface ITripDetailsForm {
  quote: IQuoteState;
  change: any;
}

class TripInfo extends React.Component<ITripDetailsForm> {
  public render() {
    const {quote} = this.props;
    let destination = quote.application.tripType === 'annual'
          ? quote.application.region
          : quote.application.destinations.join(', ');

    if (destination === 'uk') {
      destination = 'United Kingdom';
    }
    if (destination === 'europe_1') {
      destination = 'Europe';
    }
    if (destination === 'europe') {
      destination = 'Europe';
    }
    if (destination === 'europe_excluding') {
      destination = 'Europe';
    }
    if (destination === 'europe_2') {
      destination = 'Europe';
    }
    if (destination === 'worldwide_excluding') {
      destination = 'Worldwide Exc USA/Canada/Caribbean';
    }
    if (destination === 'worldwide') {
      destination = 'Worldwide Inc USA/Canada/Caribbean';
    }

    const startDate = quote.application.startDate;
    let endDate = quote.application.endDate;
    const tripType = quote.application.tripType;
    if (tripType === 'annual') {
      const [dd, mm, yyyy] = startDate.split('/').map(Number);

      const endDateNew = new Date(yyyy, mm - 1, dd);

      endDateNew.setFullYear(endDateNew.getFullYear() + 1);
      endDateNew.setDate(endDateNew.getDate() - 1);

      // tslint:disable-next-line:max-line-length
      endDate = `${String(endDateNew.getDate()).padStart(2, '0')}/${String(endDateNew.getMonth() + 1).padStart(2, '0')}/${endDateNew.getFullYear()}`;
    }
    const todayFormatted = new Intl.DateTimeFormat('en-GB').format(new Date());
    return (
      <div className="section" style={{ borderBottom: 'none' }}>
        <Row>
          <div className="traveller-section">
            <Row className="t-container">
              <Col sm={12}>
                <Col sm={12} className="traveller margin-top">
                  <h4>Trip Details</h4>
                  <Row style={{ marginBottom: '10px'}}>
                    <Col sm={12}>
                      <FormGroup controlId="destinations">
                        <Col componentClass={ControlLabel} sm={3}>
                          Destination(s)
                        </Col>
                        <Col sm={6}>
                          <Field
                              disabled={true}
                              type="text"
                              placeholder={destination}
                              component={FieldFormControl}
                              validate={[isRequired]}
                              value={destination}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  {tripType === 'single' && (
                      <Row style={{ marginBottom: '10px'}}>
                        <Col sm={12}>
                          <FormGroup controlId="startDate">
                            <Col componentClass={ControlLabel} sm={3}>
                              Cover Start Date
                            </Col>
                            <Col sm={6}>
                              <Field
                                  disabled={true}
                                  type="text"
                                  placeholder={todayFormatted}
                                  component={FieldFormControl}
                                  validate={[isRequired]}
                                  value={todayFormatted}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>
                  )}

                  <Row style={{ marginBottom: '10px'}}>
                    <Col sm={12}>
                      <FormGroup controlId="startDate">
                        <Col componentClass={ControlLabel} sm={3}>
                          {tripType === 'annual' ? 'Cover Start Date' : 'Trip Start Date'}
                        </Col>
                        <Col sm={6}>
                          <Field
                              disabled={true}
                              type="text"
                              placeholder={startDate}
                              component={FieldFormControl}
                              validate={[isRequired]}
                              value={startDate}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: '10px'}}>
                    <Col sm={12}>
                      <FormGroup controlId="startDate">
                        <Col componentClass={ControlLabel} sm={3}>
                          {tripType === 'annual' ? 'Cover End Date' : 'Trip End Date'}
                        </Col>
                        <Col sm={6}>
                          <Field
                              disabled={true}
                              type="text"
                              placeholder={endDate}
                              component={FieldFormControl}
                              validate={[isRequired]}
                              value={endDate}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Col>
            </Row>
          </div>
        </Row>
      </div>
    );
  }
}

export default TripInfo;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/PersonalDetailsB/components/TripInfo/index.tsx